import React from 'react';
import {Badge, Tooltip, Box} from '@chakra-ui/react';
import {translateState} from '../../src/shared/libs/translate';
import {TooltipState} from "../helpers/Tooltip";

export const stateColors = {
  'assignment': 'red',
  'cancelled': 'gray',
  'deleted': 'gray',
  'pending': 'gray',
  'in_queue': 'teal',
  'received_by_base': 'teal',
  'RECEIVED_BY_RESELLER ': 'teal',
  'eval_started': 'orange',
  'in_progress': 'blue',
  'pending_for_coverage': 'green',
  'customer_accepted': 'teal',
  'customer_rejected': 'red',
  'failed': 'red',
  'sent_to_base': 'blue',
  'sent_to_reseller': 'blue',
  'approval': 'green',
  'completed': 'green',
}

export function State({state, stateScoreMap, maxScore}) {
  const color = stateColors[state];
  const score = stateScoreMap[state];
  const percentage = (score / maxScore) * 100;
  return (
    <Tooltip label={TooltipState(state)} bg='gray.100' color="black" placement='bottom'>
      <Badge position='relative' variant='subtle' rounded={6}  px='1' py='1' colorScheme={color}>
        <Box position='absolute' borderLeftRadius={6} top={0} left={0} w={percentage + '%'} h='100%' bg='rgba(0, 0, 0, 0.2)' />
        <Box position='relative' zIndex={1}>{score}/{maxScore} {translateState(state)}</Box>
      </Badge>
    </Tooltip>

  )
}

export function TicketState({state}) {
  const color = stateColors[state] || 'gray';
  
  // Emoji mapping for different states
  const stateEmojis = {
    'assignment': '🔄',
    'in_queue': '⏳',
    'in_progress': '🔨',
    'completed': '✅',
    'deleted': '🗑️',
    'cancelled': '❌',
    'pending': '⏸️',
    'failed': '❗',
    'approval': '👍',
    'sent_to_base': '📤',
    'sent_to_reseller': '📤',
    'customer_accepted': '🤝',
    'customer_rejected': '👎',
  };
  
  const emoji = stateEmojis[state] || '';
  
  return (
    <Tooltip 
      label={TooltipState(state)} 
      bg='gray.100' 
      color="black" 
      placement='bottom'
      hasArrow
    >
      <Badge 
        variant='subtle' 
        rounded='full'
        px='3' 
        py='1' 
        colorScheme={color}
        display="flex"
        alignItems="center"
        boxShadow="sm"
        _hover={{ transform: 'translateY(-1px)', boxShadow: 'md' }}
        transition="all 0.2s"
      >
        {emoji && <Box mr="1">{emoji}</Box>}
        {translateState(state)}
      </Badge>
    </Tooltip>
  );
}
  

export function TaskState({state}) {
  return (
    <State 
      {...{state, maxScore: 5, stateScoreMap: {
        'assignment': 0,
        'pending': 1,
        'in_queue': 2,
        'in_progress': 3,
        'approval': 4,
        'completed': 5,
        'deleted': 5,
        'cancelled': 5
      }}}
    />
  )
}

export function ServiceState({state}) {
  const color = stateColors[state] || 'gray';
  
  // Emoji mapping for different states
  const stateEmojis = {
    'assignment': '🔄',
    'in_queue': '⏳',
    'in_progress': '🔨',
    'completed': '✅',
    'deleted': '🗑️',
    'cancelled': '❌',
    'pending': '⏸️',
    'failed': '❗',
    'approval': '👍',
    'sent_to_base': '📤',
    'sent_to_reseller': '📤',
    'customer_accepted': '🤝',
    'customer_rejected': '👎',
  };
  
  const emoji = stateEmojis[state] || '';
  
  return (
    <Tooltip 
      label={TooltipState(state)} 
      bg='gray.100' 
      color="black" 
      placement='bottom'
      hasArrow
    >
      <Badge 
        variant='subtle' 
        rounded='full'
        px='3' 
        py='1' 
        colorScheme={color}
        display="flex"
        alignItems="center"
        boxShadow="sm"
        _hover={{ transform: 'translateY(-1px)', boxShadow: 'md' }}
        transition="all 0.2s"
      >
        {emoji && <Box mr="1">{emoji}</Box>}
        {translateState(state)}
      </Badge>
    </Tooltip>
  );
}

